"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowLoyaltyDialogEvent = exports.Name = void 0;
const Name = exports.Name = 'show-loyalty-dialog';
const ShowLoyaltyDialogEvent = exports.ShowLoyaltyDialogEvent = Name;
